import React, { useState, useMemo, useEffect } from "react";
import { useFetch } from "../../hooks/useFetch";
import "./Home.css";
import { Container, Stack } from "@mui/material";
import CalendarBar from "../../components/CalendarBar";
import EventsCalendar from "../../components/EventsCalendar";
import moment from "moment";
import { useSearchParams } from "react-router";
import SearchBar from "../../components/SearchBar";
import SearchResultsList from "../../components/SearchResultsList";
//import { demoEvents } from "../../utils/data";

function Home() {
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD"),
  );
  const [activeFilters, setActiveFilters] = useState([]);
  const { data, isPending, getData } = useFetch();
  const [searchParams, setSearchParams] = useSearchParams();
  //const [searchQuery, setSearchQuery] = useState("");
  const clubID = searchParams.get("id") || "003"; // Default to "003" if no clubID is provided
  const userGUID = searchParams.get("user") || null;
  //console.log("🚀 ~ Home ~ clubID:", clubID);
  const searchQuery = searchParams.get("search") || ""; // Default to empty string if no search query is provided

  const handleSearchChange = (value) => {
    const newParams = new URLSearchParams(searchParams);
    if (value) {
      newParams.set("search", value);
    } else {
      newParams.delete("search");
    }
    setSearchParams(newParams, { replace: true });
  };

  const searchedEvents = useMemo(() => {
    if (!searchQuery.trim() || !data) return [];

    const query = searchQuery.toLowerCase();
    return data.filter(
      (event) =>
        event.title?.toLowerCase().includes(query) ||
        event.description?.toLowerCase().includes(query),
    );
  }, [data, searchQuery]);

  const handleFilterToggle = (clickedType) => {
    if (clickedType === "All") {
      setActiveFilters([]);
      return;
    }
    setActiveFilters((prevFilters) => {
      if (prevFilters.includes(clickedType)) {
        return prevFilters.filter((type) => type !== clickedType);
      }
      return [...prevFilters, clickedType];
    });
  };

  useEffect(() => {
    // when we receive the data, save it to localStorage for offline access
    if (data) {
      localStorage.setItem("eventsData", JSON.stringify(data));
    }
  }, [data]);

  useEffect(() => {
    if (userGUID) {
      localStorage.setItem("user", userGUID);
    }
  }, [userGUID]);

  useEffect(() => {
    if (clubID) {
      localStorage.setItem("clubID", clubID);
      getData(`event/allevents/${clubID}`);
    }
  }, [clubID, getData]);

  const filteredEvents = useMemo(() => {
    if (!data) return [];
    return activeFilters.length === 0
      ? data
      : data.filter((event) => activeFilters.includes(event.eventType));
  }, [data, activeFilters]);

  if (isPending) {
    return <div>Loading...</div>;
  }

  //console.log(data);

  return (
    <Container
      size={{ xs: "sm", md: "lg" }}
      alignItems="center"
      justifyContent="center"
      sx={{ mt: 2, mb: 2, mx: "auto", padding: { xs: 2, md: 0 } }}
    >
      <Stack
        spacing={2}
        alignItems="center"
        style={{ height: 700, maxWidth: 700, margin: "0 auto" }}
      >
        <SearchBar searchQuery={searchQuery} setSearchQuery={handleSearchChange} />
        {searchQuery.trim().length > 0 ? (
          <SearchResultsList
            events={searchedEvents}
            searchQuery={searchQuery}
          />
        ) : (
          <>
            <CalendarBar
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              filteredEvents={filteredEvents}
            />
            <EventsCalendar
              selectedDate={selectedDate}
              activeFilters={activeFilters}
              handleFilterToggle={handleFilterToggle}
              filteredEvents={filteredEvents}
              onDateChange={setSelectedDate}
            />
          </>
        )}
      </Stack>
    </Container>
  );
}

export default Home;
